export default "__VITE_ASSET__mfxY_vwZ__"